/* EMBR — animaciones y comportamiento de las secciones personalizadas */
(function () {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Aparición al hacer scroll
  const io =
    'IntersectionObserver' in window
      ? new IntersectionObserver(
          (entries) => {
            entries.forEach((e) => {
              if (!e.isIntersecting) return;
              e.target.classList.add('is-in');
              io.unobserve(e.target);
            });
          },
          { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
        )
      : null;

  // Contadores animados (4,2 g · 6,5 W · 10 s…)
  function countUp(el) {
    const raw = el.getAttribute('data-count') || '';
    const decimals = (raw.split(/[.,]/)[1] || '').length;
    const sep = raw.includes(',') ? ',' : '.';
    const target = parseFloat(raw.replace(',', '.'));
    if (isNaN(target) || reduce) return;
    const start = performance.now();
    const dur = 1400;
    const tick = (now) => {
      const p = Math.min(1, (now - start) / dur);
      const v = target * (1 - Math.pow(1 - p, 3));
      el.textContent = v.toFixed(decimals).replace('.', sep);
      if (p < 1) requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
  }
  const counterIO =
    'IntersectionObserver' in window
      ? new IntersectionObserver(
          (entries) => {
            entries.forEach((e) => {
              if (!e.isIntersecting) return;
              countUp(e.target);
              counterIO.unobserve(e.target);
            });
          },
          { threshold: 0.6 }
        )
      : null;

  // Barra de compra fija: aparece siempre que el botón principal NO esté en pantalla
  // (antes de llegar a él o después de pasarlo). Clarity 30 sep: el 83% en celular no baja
  // del primer 10% de la página, así que nunca veían precio ni botón.
  function initSticky(root) {
    const bar = root.querySelector('[data-embr-sticky]');
    if (!bar) return;
    const target = document.querySelector('product-form, .product-form');
    if (!target || bar.dataset.ready) return;
    bar.dataset.ready = '1';
    const footer = document.querySelector('.footer, footer');
    let ticking = false;
    const update = () => {
      ticking = false;
      const r = target.getBoundingClientRect();
      const formHidden = r.bottom < 0 || r.top > window.innerHeight - 60;
      const atFooter = footer ? footer.getBoundingClientRect().top < window.innerHeight : false;
      bar.classList.toggle('is-shown', formHidden && !atFooter);
    };
    const onScroll = () => {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(update);
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    update();
    const btn = bar.querySelector('[data-embr-buy]');
    if (btn)
      btn.addEventListener('click', (ev) => {
        const submit = document.querySelector('product-form button[type="submit"], .product-form__submit');
        if (!submit) return;
        ev.preventDefault();
        // Si todavía no ha visto las opciones (talla/color), lo llevamos a elegirlas primero
        const picker = document.querySelector('variant-selects, .product-form__input');
        if (picker && !bar.dataset.visto && target.getBoundingClientRect().top > 0) {
          bar.dataset.visto = '1';
          (picker.closest('variant-selects') || picker).scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }
        if (submit.disabled) {
          submit.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }
        submit.click();
      });
    // Precio de la variante elegida
    const priceEl = bar.querySelector('[data-embr-price]');
    document.addEventListener('change', () => {
      setTimeout(() => {
        const p = document.querySelector('.product__info-container .price__container .price-item--last, .product__info-container .price-item--regular');
        if (p && priceEl) priceEl.textContent = p.textContent.trim();
      }, 350);
    });
  }

  // Respaldo por scroll: garantiza que nada se quede oculto aunque el navegador no avise
  let pending = [];
  let rafQueued = false;
  function checkPending() {
    rafQueued = false;
    const limit = window.innerHeight * 0.95;
    pending = pending.filter((el) => {
      if (el.getBoundingClientRect().top < limit) {
        el.classList.add('is-in');
        return false;
      }
      return true;
    });
  }
  const queueCheck = () => {
    if (!rafQueued) {
      rafQueued = true;
      requestAnimationFrame(checkPending);
    }
  };
  window.addEventListener('scroll', queueCheck, { passive: true });
  window.addEventListener('resize', queueCheck);
  // Último recurso: si en 6 s algo sigue oculto en pantalla, se muestra
  setTimeout(checkPending, 6000);

  function init(root) {
    root = root || document;
    root.querySelectorAll('.embr [data-reveal]').forEach((el) => {
      if (io && !reduce && !window.Shopify?.designMode) {
        io.observe(el);
        pending.push(el);
      } else el.classList.add('is-in');
    });
    queueCheck();
    root.querySelectorAll('.embr [data-count]').forEach((el) => {
      if (counterIO && !window.Shopify?.designMode) counterIO.observe(el);
    });
    initSticky(root);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();

  // En el editor de Shopify, reiniciar cada vez que se modifica una sección
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
